export default __webpack_public_path__ + "static/avatar-mp-kayi-female-0-v4-598fbfaeea20f13ead4e501cc4bbea9b.png";